import React from "react";
import LightBoxModal from "./LightBoxModal";

const ImageLightBox = ({ imageUrl, isOpen, onClose }) =>
  isOpen ? <LightBoxModal imageUrl={imageUrl} close={onClose} /> : null;

export default ImageLightBox;
